<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:36:37+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe Language switcher
@Last modified by:   tom
@Last modified time: 2019-06-04T15:36:30+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Example:     <locale-switcher :locales="['en', 'nl']" :show-full="true" class="pl-4"/>

-->

<template>
  <div class="locale-switcher">
    <!-- {{ initLocale() }} -->
    <b-nav-item-dropdown :dropup="dropup" :text="dropdownLbl" right>
      <b-dropdown-item
        v-for="locale in locales"
        :key="locale.id"
        :class="{ 'is-current': locale === activeLocale }"
        class="locale-link"
        href="#"
        @click="setLocale(locale)">
        {{ getLanguageString(locale) }}
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>

const localeStrings = {
  en: 'English',
  us: 'USA - English',
  uk: 'UK- English',
  nl: 'Nederlands',
  ru: 'Russian',
  ua: 'Ukrainian',
  fr: 'Français',
  de: 'Deutsch'
}

export default {
  props: {
    locales: {
      type: Array,
      default: () => ['en']
    },
    showFull: {
      type: Boolean,
      default: false
    },
    dropup: {
      type: Boolean,
      default: false
    },
    locLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    dropdownLbl: function () {
      return this.locLabel ? this.locLabel : this.activeLocale
    },
    activeLocale: function () {
      return this.$store.getters['app/setting']('language')
    }
  },
  methods: {
    setLocale: function (locale) {
      this.$store.commit('app/setting', { set: 'language', value: locale })
      // we are in need of refresh, as drop down forms dont follow the reactivty... :(
      // this.$router.go()
    },
    getLanguageString: function (locale) {
      return this.showFull ? localeStrings[locale] : locale
    }
  }
}
</script>

<style lang="scss">
  .locale-switcher {
    display: inline-block;
    .dropdown-menu {
      font-size: 0.7em !important;
      padding: 2px;
      text-transform: uppercase;
    }
  }

</style>
